<template>
  <li class="card p-2 mb-2 d-flex flex-row">

    <img
      v-if="cachedAppContent.cachedPicture"
      :src="cachedAppContent.cachedPicture"
      height="64px"
      class="mr-2" />

    <div>

      <!-- Check invitation type -->
      <template v-if="cachedAppContent.goalId">

        Invitation for

        <router-link :to="'/goal/' + cachedAppContent.goalId + '/dashboard'">
          <strong>{{cachedAppContent.cachedName}}</strong>
        </router-link>

        sent to<br />

      </template>
      <template v-else>

        <strong>Contact request</strong> sent to
        <!-- TODO: also show message here -->

      </template>

      <template v-if="invitation.email">
        <strong>{{invitation.email}}</strong>
      </template>
      <template v-else>
        <!-- <pre>{{contact.displayName}}</pre> -->
        <user-mini-avatar :user-id="invitation.receiverUserId" :show-name="true" size="small" />
      </template>

      on {{invitation.createdAt | longDate}}

      <br />

      <!-- TODO: {{invitation.cachedAppContent}} -->
      <!-- TODO: Show info when user has signed up -->

      ( <a href="#" @click.stop="onRevokeInvitation(invitation)">revoke</a>,
      <a href="#" @click.stop="onInvitationShowDetails(invitation)">show details</a> )
    </div>

    <portal to="modal-target-goal-details">
      <el-dialog
        title="Invitation details"
        width="30%"
        :visible.sync="showDetailsDialog"
        @closed="invitationDetails = null"
        v-if="invitationDetails">
        <pre class="mini-pre">{{invitationDetails.$state}}</pre>
        <span v-if="invitationDetails.status === 0">
          Waiting...
        </span>
        <span v-if="invitationDetails.numMailsSent > 0">
          Invitation has been send
        </span>
      </el-dialog>
    </portal>
  </li>
</template>

<script>
// TODO: Positioning bug, when creating or deleting invitations

export default {
  props: {
    invitation: {
      required: true
    }
  },
  data() {
    return {
      showDetailsDialog: false,
      invitationDetails: null,
    };
  },
  mounted() {
    // TODO: The problem at this point it that we're not friends with the user
    // this means we can only fetch his public information, if he wants to
    // this.$api.contact_add_if_not_cached( this.invitation.receiverUserId );
  },
  computed: {
    cachedAppContent() {
      return JSON.parse( this.invitation.cachedAppContent )
    },

    // contact() {
    //   return this.$models.userContact.get_contact_by_id( this.invitation.receiverUserId ) || {
    //     displayName: 'loading...'
    //   }
    // }
  },
  methods: {
    onRevokeInvitation(invitation) {
      let invitationCode = invitation.$id;
      if ( invitation.email ) {
        this.$api.invitation_revoke_new_user({
          email: invitation.email,
          invitationCode,
        })
      } else if ( invitation.receiverUserId ) {
        this.$api.invitation_revoke_existings_user({
          receiverUserId: invitation.receiverUserId,
          invitationId: invitationCode
        })
      }
    },

    onInvitationShowDetails(invitation) {
      console.log("onInvitationShowDetails", invitation)

      let data = null;

      if ( invitation.receiverUserId ) {
        // This is an internal invitation

        // TODO: show invitaiton from "/user/{uid}/incomming_invitations/*"
        /* data = this.$models.userIncommingInvitation
          .with({ uid: invitation.receiverUserId })
          .fetchNode( invitationId ??? ) */

        let invitationId = invitation.$id // same same
        console.log("invitationId", invitationId)

        // TODO: We have to save the invitationId in the outgoing invitation, otherwise
        // we can't fetch it here

        data = {
          $state: this.cachedAppContent,
          $promise: Promise.resolve(),
        }

      } else {
        // This is an external invitation send by email

        data = this.$models.invitation
          .with({ email: btoa( invitation.email ) })
          .fetchNode(invitation.invitationCode)
      }

      data.$promise.then(() => {
        this.showDetailsDialog = true;
        this.invitationDetails = data;
      })
    },
  }
};
</script>
